import { IMAGES } from './images';
// ===========================================
// ÖVNINGSBIBLIOTEK - KOMPLETT
// ===========================================
const EXERCISES = {
  // ============================================
  // BEN & RUMPA - BASÖVNINGAR
  // ============================================
  squat: {
    name: 'Knäböj (Back Squat)',
    muscle: 'Främre lår, Rumpa, Core',
    equipment: 'Skivstång + Rack',
    image: IMAGES.squat,
    isCompound: true,
    importance: 'BASÖVNING',
    description: 'Kungen av alla benövningar. Tränar i princip hela kroppen med fokus på lår och rumpa. En av de viktigaste övningarna du kan göra.',
    steps: [
      'Placera stången på övre ryggen (trapezius), inte på nacken',
      'Stå med fötterna axel- till höftbrett, tårna pekar 15-30° utåt',
      'Ta ett djupt andetag och spänn magen (valsalva-manöver)',
      'Sätt dig bakåt och ner - tänk "sitt ner mellan benen"',
      'Gå ner tills höften är i linje med eller under knäna',
      'Pressa upp genom hela foten, håll bröstet uppe hela vägen'
    ],
    tips: 'Knäna ska följa tårnas riktning. Undvik att knäna faller inåt. Ryggen ska vara rak genom hela rörelsen.'
  },
  conventionalDeadlift: {
    name: 'Marklyft (Conventional)',
    muscle: 'Baksida lår, Rumpa, Rygg, Core',
    equipment: 'Skivstång',
    image: IMAGES.conventionalDeadlift,
    isCompound: true,
    importance: 'BASÖVNING',
    description: 'Den ultimata helkroppsövningen. Bygger enorm styrka i hela bakre kedjan. Fundamental för funktionell styrka.',
    steps: [
      'Stå med fötterna höftbrett, tårna under stången',
      'Böj dig ner och grip stången strax utanför benen',
      'Sänk höften tills skenbenen nuddar stången',
      'Bröst upp, rygg rak, blicken framåt',
      'Pressa golvet ifrån dig och res dig upp samtidigt som höften och axlar',
      'Lås ut i toppen med rumpan spänd och axlarna tillbaka'
    ],
    tips: 'Stången ska gå så nära kroppen som möjligt. Börja med lätt vikt och perfekta tekniken!'
  },
  frontSquat: {
    name: 'Frontböj (Front Squat)',
    muscle: 'Främre lår, Core, Övre rygg',
    equipment: 'Skivstång',
    image: IMAGES.frontSquat,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Mer quadriceps-dominant än back squat. Kräver god rörlighet och bygger stark core och övre rygg.',
    steps: [
      'Placera stången på främre axlarna (deltoiderna)',
      'Armbågarna högt - parallella med golvet',
      'Stå axelbrett, tårna lätt utåt',
      'Håll överkroppen upprätt genom hela rörelsen',
      'Gå ner så djupt du kan med bibehållen teknik',
      'Pressa upp genom hela foten'
    ],
    tips: 'Om handledsrörligheten begränsar - använd korslagt armgrepp eller straps.'
  },
  romanianDeadlift: {
    name: 'Rumänsk marklyft (RDL)',
    muscle: 'Baksida lår, Rumpa, Nedre rygg',
    equipment: 'Skivstång / Hantlar',
    image: IMAGES.romanianDeadlift,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Bästa övningen för baksida lår. Bygger styrka och rörlighet i hela bakre kedjan.',
    steps: [
      'Stå med fötterna höftbrett, lätt böjda knän',
      'Håll vikten med raka armar framför dig',
      'Skjut höften bakåt och sänk vikten längs benen',
      'Känn stretch i baksida lår - ryggen rak hela tiden',
      'Gå ner till strax under knähöjd (beroende på rörlighet)',
      'Pressa höften framåt och kläm rumpan i toppen'
    ],
    tips: 'Tänk "skjut rumpan mot väggen bakom dig". Vikten ska hela tiden vara nära kroppen.'
  },
  bulgarianSplitSquat: {
    name: 'Bulgariska utfall',
    muscle: 'Främre lår, Rumpa, Balans',
    equipment: 'Bänk + Hantlar (valfritt)',
    image: IMAGES.bulgarianSplit,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Ensidig övning som bygger styrka och fixar obalanser. Utmärkt för atleter.',
    steps: [
      'Stå ca 60 cm framför en bänk',
      'Placera vristen på bänken bakom dig',
      'Främre foten platt i golvet, lätt framåtlutad',
      'Sänk bakre knät rakt ner mot golvet',
      'Främre knät ska vara i linje med tårna',
      'Pressa upp genom främre hälen'
    ],
    tips: 'Justera avståndet från bänken tills det känns bekvämt. Håll hantlar för extra motstånd.'
  },
  hipThrust: {
    name: 'Hip Thrust',
    muscle: 'Rumpa (Gluteus maximus)',
    equipment: 'Bänk + Skivstång/Hantlar',
    image: IMAGES.hipThrust,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Bästa isoleringsövningen för rumpan. Bygger styrka och volym i gluteus.',
    steps: [
      'Sitt med övre ryggen mot en bänk',
      'Placera skivstången över höftvecket (använd pad)',
      'Fötter platt i golvet, axelbrett',
      'Pressa höften rakt upp genom att klämma rumpan',
      'I toppen ska kroppen bilda en rak linje från knä till axel',
      'Håll 1-2 sekunder, sänk kontrollerat'
    ],
    tips: 'Undvik att överstrecka ryggen i toppen. All kraft ska komma från rumpan.'
  },
  legPress: {
    name: 'Benpress',
    muscle: 'Främre lår, Rumpa',
    equipment: 'Benpress-maskin',
    image: IMAGES.legPress,
    isCompound: false,
    importance: 'VIKTIG',
    description: 'Säkert sätt att träna ben tungt. Bra komplement eller ersättning till knäböj.',
    steps: [
      'Sitt med ryggen platt mot ryggstödet',
      'Fötter höftbrett på plattan',
      'Släpp bromsarna och böj knäna kontrollerat',
      'Gå ner tills knäna är i 90°',
      'Pressa plattan ifrån dig utan att låsa knäna i toppen'
    ],
    tips: 'Låt aldrig rumpan lyfta från sätet. Placera fötterna högre för mer rumpa, lägre för mer quad.'
  },
  lunge: {
    name: 'Utfall',
    muscle: 'Främre lår, Rumpa',
    equipment: 'Ingen / Hantlar',
    image: IMAGES.lunge,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Funktionell benövning som tränar styrka, balans och koordination.',
    steps: [
      'Stå upprätt med fötterna höftbrett',
      'Ta ett stort steg framåt',
      'Sänk bakre knät rakt ner mot golvet',
      'Båda knäna i 90° i botten',
      'Pressa upp genom främre hälen till start',
      'Alternera ben eller gör alla reps på samma ben'
    ],
    tips: 'Håll överkroppen upprätt. Undvik att främre knät går förbi tårna.'
  },
  legExtension: {
    name: 'Bensträck',
    muscle: 'Främre lår (Quadriceps)',
    equipment: 'Bensträck-maskin',
    image: IMAGES.legExtension,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Isolerar quadriceps. Bra för att "finisha" låren efter tunga övningar.',
    steps: [
      'Sitt i maskinen med ryggen mot ryggstödet',
      'Ankelkudden ska vara strax ovanför foten',
      'Sträck benen genom att kontrahera quadriceps',
      'Håll i toppen 1 sekund',
      'Sänk kontrollerat - motverka vikten hela vägen'
    ],
    tips: 'Använd inte för tung vikt. Fokusera på kontroll och squeeze i toppen.'
  },
  legCurl: {
    name: 'Bencurl',
    muscle: 'Baksida lår (Hamstrings)',
    equipment: 'Bencurl-maskin',
    image: IMAGES.legCurl,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Isolerar baksida lår. Viktigt för balans mellan fram- och baksida.',
    steps: [
      'Ligg på magen med vadorna under dynan',
      'Höfterna ska vara pressade mot bänken',
      'Böj knäna och dra hälarna mot rumpan',
      'Kläm i toppen en sekund',
      'Sänk kontrollerat tillbaka'
    ],
    tips: 'Lyft inte höften från bänken. Full rörelseomfång för bäst resultat.'
  },
  calfRaise: {
    name: 'Vadpress',
    muscle: 'Vader (Gastrocnemius, Soleus)',
    equipment: 'Trappsteg / Maskin',
    image: IMAGES.calfRaise,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Bygger vadmusklerna. Ofta bortglömd men viktig för komplett benutveckling.',
    steps: [
      'Stå på ett trappsteg med hälarna utanför kanten',
      'Håll i något för balans om det behövs',
      'Sänk hälarna så långt ner du kan (full stretch)',
      'Res dig upp på tå så högt du kan',
      'Håll en sekund i toppen och kläm vaderna'
    ],
    tips: 'Full rörelseomfång är viktigt. Gör övningen långsamt och kontrollerat.'
  },
  gluteBridge: {
    name: 'Höftlyft / Glute Bridge',
    muscle: 'Rumpa, Baksida lår',
    equipment: 'Ingen',
    image: IMAGES.gluteBridge,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Aktiverar och stärker rumpan. Perfekt som uppvärmning eller för nybörjare.',
    steps: [
      'Ligg på rygg med böjda knän, fötter platt i golvet',
      'Fötterna höftbrett, nära rumpan',
      'Pressa höften uppåt genom att klämma rumpan',
      'Kroppen rak linje från knä till axel i toppen',
      'Håll 1-2 sek, sänk kontrollerat'
    ],
    tips: 'Pressa verkligen ihop rumpan i toppen. Undvik att överstrecka ryggen.'
  },

  // ============================================
  // BRÖST - ÖVNINGAR
  // ============================================
  benchPress: {
    name: 'Bänkpress',
    muscle: 'Bröst, Främre axel, Triceps',
    equipment: 'Bänk + Skivstång',
    image: IMAGES.benchPress,
    isCompound: true,
    importance: 'BASÖVNING',
    description: 'Den klassiska överkroppsövningen. Bygger bröst, axlar och triceps. En av "The Big Three".',
    steps: [
      'Ligg på bänken med ögonen under stången',
      'Grepp lite bredare än axelbrett',
      'Dra ihop skulderbladen och tryck dem ner i bänken',
      'Tryck bröstet uppåt (skapa en liten "båge")',
      'Sänk stången kontrollerat till bröstet (vid bröstvårtorna)',
      'Pressa upp till raka armar, armbågarna låsta i toppen'
    ],
    tips: 'Fötterna stadigt i golvet. Skulderbladen ihoptryckta genom hela rörelsen.'
  },
  inclineBenchPress: {
    name: 'Lutande bänkpress',
    muscle: 'Övre bröst, Axlar, Triceps',
    equipment: 'Lutande bänk + Skivstång/Hantlar',
    image: IMAGES.inclinePress,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Fokuserar mer på övre delen av bröstet. Nödvändig för komplett bröstutveckling.',
    steps: [
      'Ställ bänken i 30-45 graders lutning',
      'Ligg med ryggen mot bänken, skulderblad ihoptryckta',
      'Grepp axelbrett eller lite bredare',
      'Sänk vikten till övre bröstet',
      'Pressa rakt upp över bröstlinjen'
    ],
    tips: '30-45° är idealiskt. Högre vinkel tränar mer axlar än bröst.'
  },
  dumbbellPress: {
    name: 'Hantelpress',
    muscle: 'Bröst, Axlar, Triceps',
    equipment: 'Bänk + Hantlar',
    image: IMAGES.dumbbellPress,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Tillåter större rörelseomfång än stång. Bra för att fixera obalanser mellan sidorna.',
    steps: [
      'Ligg på bänken med hantlar vid axlarna',
      'Handflatorna vänder framåt',
      'Pressa vikterna upp och låt dem mötas i toppen',
      'Sänk kontrollerat ut åt sidorna',
      'Känn stretch i bröstet i botten'
    ],
    tips: 'Låt inte hantlarna sänkas för långt - stopp när överarmarna är parallella med golvet.'
  },
  pushUp: {
    name: 'Armhävningar',
    muscle: 'Bröst, Axlar, Triceps',
    equipment: 'Ingen',
    image: IMAGES.pushup,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Klassisk kroppsviktsövning. Kan göras överallt och modifieras för alla nivåer.',
    steps: [
      'Händer på golvet, lite bredare än axelbrett',
      'Kroppen helt rak från huvud till hälar',
      'Spänn magen och rumpan',
      'Sänk bröstet mot golvet genom att böja armarna',
      'Gå ner tills bröstet nästan nuddar golvet',
      'Pressa upp till raka armar'
    ],
    tips: 'På knä för enklare, fötter upphöjda för svårare. Armbågarna 45° från kroppen.'
  },
  dips: {
    name: 'Dips',
    muscle: 'Bröst, Triceps, Axlar',
    equipment: 'Dip-station / Parallella stänger',
    image: IMAGES.dips,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Fantastisk övning för nedre bröst och triceps. "Överkroppens knäböj".',
    steps: [
      'Grip stängerna med raka armar',
      'Korsa fötterna bakom dig',
      'Luta överkroppen framåt (ca 30° för bröstfokus)',
      'Sänk kroppen tills överarmarna är parallella med golvet',
      'Pressa upp till raka armar'
    ],
    tips: 'Mer framåtlutning = mer bröst. Mer upprätt = mer triceps. Lägg till vikt med bälte när du klarar 15+ reps.'
  },
  chestFly: {
    name: 'Chest Fly / Bröstkors',
    muscle: 'Bröst',
    equipment: 'Hantlar / Kabel',
    image: IMAGES.chestFly,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Isoleringsövning som ger maximal stretch och kontraktion i bröstet.',
    steps: [
      'Ligg på bänk med hantlar rakt upp över bröstet',
      'Armar nästan raka med lätt böjda armbågar',
      'Sänk armarna ut åt sidorna i en båge',
      'Känn stretch i bröstet, stopp i axelhöjd',
      'Dra ihop armarna uppåt som att du kramar ett träd'
    ],
    tips: 'Bibehåll samma böjning i armbågarna hela tiden. Kontrollera rörelsen.'
  },
  cableCrossover: {
    name: 'Cable Crossover',
    muscle: 'Bröst',
    equipment: 'Kabelstation',
    image: IMAGES.cableCrossover,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Konstant spänning genom hela rörelsen. Utmärkt finisher för bröstpasset.',
    steps: [
      'Ställ kablar i hög position',
      'Stå i mitten med ett steg framåt',
      'Dra handtagen framåt och nedåt i en båge',
      'Korsa händerna framför kroppen',
      'Kläm bröstet hårt, släpp tillbaka kontrollerat'
    ],
    tips: 'Experimentera med kabelns höjd för att träffa olika delar av bröstet.'
  },

  // ============================================
  // RYGG - ÖVNINGAR
  // ============================================
  barbellRow: {
    name: 'Skivstångsrodd',
    muscle: 'Övre rygg, Lats, Biceps',
    equipment: 'Skivstång',
    image: IMAGES.barbellRow,
    isCompound: true,
    importance: 'BASÖVNING',
    description: 'Huvudövning för ryggstyrka och massa. Bygger tjock, stark rygg.',
    steps: [
      'Stå med fötterna höftbrett, böj framåt med rak rygg',
      'Överkroppen i 45-60° vinkel mot golvet',
      'Grip stången axelbrett, hängande armar',
      'Dra stången mot nedre magen/naveln',
      'Kläm skulderbladen hårt i toppen',
      'Sänk kontrollerat till raka armar'
    ],
    tips: 'Håll ryggen i samma vinkel genom hela rörelsen. Ingen svängning!'
  },
  pullUp: {
    name: 'Pull-ups',
    muscle: 'Latissimus, Biceps, Övre rygg',
    equipment: 'Pull-up stång',
    image: IMAGES.pullUp,
    isCompound: true,
    importance: 'BASÖVNING',
    description: 'Kungen av ryggövningar. Bygger V-form och imponerande ryggbredd.',
    steps: [
      'Grip stången med överslagsgrepp, bredare än axelbrett',
      'Häng med raka armar och skulderblad ihopdragna',
      'Dra dig upp genom att föra armbågarna ner och bakåt',
      'Fortsätt tills hakan är över stången',
      'Sänk kontrollerat hela vägen ner'
    ],
    tips: 'Klarar du inte en hel? Gör negativa (hoppa upp, sänk långsamt) eller använd band.'
  },
  chinUp: {
    name: 'Chin-ups',
    muscle: 'Latissimus, Biceps',
    equipment: 'Pull-up stång',
    image: IMAGES.chinUp,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Som pull-ups men med underslagsgrepp. Mer biceps-fokus och ofta lättare för nybörjare.',
    steps: [
      'Grip stången med underslagsgrepp (handflator mot dig)',
      'Grepp axelbrett eller lite smalare',
      'Häng med raka armar',
      'Dra dig upp tills hakan är över stången',
      'Fokusera på att dra med ryggen, inte bara armarna'
    ],
    tips: 'Utmärkt övning för biceps OCH rygg samtidigt.'
  },
  latPulldown: {
    name: 'Latsdrag',
    muscle: 'Latissimus, Biceps',
    equipment: 'Kabelmaskin',
    image: IMAGES.latPulldown,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Maskinvariant av pull-ups. Bra för nybörjare och för att träna med specifik belastning.',
    steps: [
      'Sitt i maskinen med låren under dynorna',
      'Grip stången bredare än axelbrett',
      'Dra stången ner mot övre bröstet',
      'Tryck bröstet uppåt och kläm skulderbladen',
      'Släpp upp kontrollerat med full stretch i toppen'
    ],
    tips: 'Dra med ryggen - tänk "armbågar ner och bakåt", inte "händer ner".'
  },
  seatedRow: {
    name: 'Sittande rodd (Cable Row)',
    muscle: 'Mellanrygg, Lats, Biceps',
    equipment: 'Kabelmaskin',
    image: IMAGES.seatedRow,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Bygger ryggtjocklek. Konstant spänning genom hela rörelsen.',
    steps: [
      'Sitt med lätt böjda knän, fötterna på plattan',
      'Grip handtaget med raka armar',
      'Dra handtaget mot magen, armbågar nära kroppen',
      'Kläm skulderbladen i slutpositionen',
      'Släpp tillbaka kontrollerat utan att runda ryggen'
    ],
    tips: 'Svinga inte med överkroppen. Kraften ska komma från ryggen.'
  },
  dumbbellRow: {
    name: 'Hantelrodd (Enarms)',
    muscle: 'Latissimus, Övre rygg, Biceps',
    equipment: 'Hantel + Bänk',
    image: IMAGES.dumbbellRow,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Ensidig roddövning. Bra för att korrigera obalanser och få full kontraktion.',
    steps: [
      'Placera ett knä och en hand på bänken',
      'Andra foten på golvet, hantel i handen',
      'Ryggen platt och parallell med golvet',
      'Dra hanteln mot höften, armbåge nära kroppen',
      'Kläm skulderbladen i toppen',
      'Sänk kontrollerat och känn stretch'
    ],
    tips: 'Rotera inte i överkroppen - håll axlarna parallella med golvet.'
  },
  tBarRow: {
    name: 'T-Bar Rodd',
    muscle: 'Mellanrygg, Lats',
    equipment: 'T-Bar maskin / Landmine',
    image: IMAGES.tBarRow,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Klassisk bodybuilding-övning för ryggmassa. Tillåter tunga vikter.',
    steps: [
      'Stå över stången med fötterna axelbrett',
      'Böj framåt med rak rygg',
      'Grip handtaget med båda händerna',
      'Dra vikten mot bröstet',
      'Kläm skulderbladen hårt i toppen',
      'Sänk kontrollerat'
    ],
    tips: 'Håll ryggen rak och bröstkorgen uppe. Fokusera på squeeze i toppen.'
  },
  facePull: {
    name: 'Face Pull',
    muscle: 'Bakre axlar, Övre rygg',
    equipment: 'Kabel med rep',
    image: IMAGES.facePull,
    isCompound: false,
    importance: 'VIKTIG',
    description: 'Ovärderlig för axelhälsa och hållning. Balanserar alla pressövningar.',
    steps: [
      'Ställ kabeln i ansiktshöjd',
      'Grip repet med överhandsgrepp',
      'Dra mot ansiktet och separera händerna',
      'Rotera händerna utåt i slutpositionen',
      'Kläm skulderbladen och håll en sekund'
    ],
    tips: 'Lätt vikt, hög volym. 15-25 reps. Gör denna övning ofta!'
  },
  shrugs: {
    name: 'Axelryckningar (Shrugs)',
    muscle: 'Trapezius (övre)',
    equipment: 'Skivstång / Hantlar',
    image: IMAGES.shrugs,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Bygger trapeziusmuskeln för den tjocka "nacklooken".',
    steps: [
      'Stå med vikterna hängande vid sidorna',
      'Lyft axlarna rakt upp mot öronen',
      'Håll i toppen och kläm trapezius',
      'Sänk kontrollerat',
      'Rotera INTE axlarna - rakt upp och ner'
    ],
    tips: 'Tung vikt är okej, men full rörelse är viktigare. Håll 2-3 sek i toppen.'
  },

  // ============================================
  // AXLAR - ÖVNINGAR
  // ============================================
  overheadPress: {
    name: 'Militärpress / Axelpress',
    muscle: 'Axlar (alla huvuden), Triceps',
    equipment: 'Skivstång',
    image: IMAGES.overheadPress,
    isCompound: true,
    importance: 'BASÖVNING',
    description: 'Fundamental pressövning för axelstyrka. En av de bästa övningarna för överkroppsstyrka.',
    steps: [
      'Stå med fötterna höftbrett, stången på främre axlarna',
      'Grepp strax bredare än axelbrett',
      'Spänn magen och rumpan',
      'Pressa stången rakt upp, flytta huvudet bakåt',
      'Lås ut ovanför huvudet, huvudet "genom fönstret"',
      'Sänk kontrollerat tillbaka till axlarna'
    ],
    tips: 'Håll core spänt! Undvik att luta bakåt för att lyfta mer.'
  },
  dumbbellShoulderPress: {
    name: 'Hantelpress (axlar)',
    muscle: 'Axlar, Triceps',
    equipment: 'Hantlar',
    image: IMAGES.overheadPress,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Tillåter mer naturlig rörelse än stång. Bra för nybörjare och som variation.',
    steps: [
      'Sitt eller stå med hantlar i axelhöjd',
      'Handflatorna vänder framåt',
      'Pressa vikterna rakt upp',
      'Låt dem mötas i toppen',
      'Sänk kontrollerat tillbaka till axlarna'
    ],
    tips: 'Sitt för stabilare position, stå för mer core-aktivering.'
  },
  arnoldPress: {
    name: 'Arnold Press',
    muscle: 'Axlar (alla huvuden)',
    equipment: 'Hantlar',
    image: IMAGES.arnoldPress,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Uppkallad efter Arnold Schwarzenegger. Rotationen tränar alla tre axelhuvudena.',
    steps: [
      'Sitt med hantlar i axelhöjd, handflatorna mot dig',
      'Pressa upp samtidigt som du roterar handflatan framåt',
      'I toppen ska handflatorna vara vända framåt',
      'Sänk och rotera tillbaka till startpositionen'
    ],
    tips: 'Kontrollerad rörelse - rotationen är lika viktig som pressen.'
  },
  lateralRaise: {
    name: 'Sidolyft',
    muscle: 'Sidoaxel (Lateral deltoid)',
    equipment: 'Hantlar / Kabel',
    image: IMAGES.lateralRaise,
    isCompound: false,
    importance: 'VIKTIG',
    description: 'Bygger breda axlar. Den viktigaste isoleringsövningen för sidoaxeln.',
    steps: [
      'Stå med hantlar vid sidorna',
      'Lätt böjda armbågar genom hela rörelsen',
      'Lyft armarna ut åt sidorna till axelhöjd',
      'Handflatorna vänder nedåt eller lätt framåt',
      'Sänk kontrollerat'
    ],
    tips: 'Tänk "häll ut vatten ur kannor" i toppen. Lätt vikt, kontrollerad rörelse.'
  },
  frontRaise: {
    name: 'Frontlyft',
    muscle: 'Främre axel',
    equipment: 'Hantlar / Stång',
    image: IMAGES.frontRaise,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Tränar främre delen av axeln. Bra komplement till pressövningar för att bygga starka, väldefinierade axlar.',
    steps: [
      'Stå med hantlar framför låren',
      'Lyft en eller båda armarna rakt framåt',
      'Stopp i axelhöjd - inte högre',
      'Håll kort i toppen',
      'Sänk kontrollerat'
    ],
    tips: 'Ofta onödig om du gör mycket press. Prioritera sidolyft och bakre axel istället.'
  },
  rearDeltFly: {
    name: 'Bakre axellyft / Rear Delt Fly',
    muscle: 'Bakre axel',
    equipment: 'Hantlar / Maskin',
    image: IMAGES.rearDeltFly,
    isCompound: false,
    importance: 'VIKTIG',
    description: 'Kritisk för axelbalans och hållning. Ofta undertränad!',
    steps: [
      'Böj framåt i höften, bröst mot låren',
      'Hantlar hängande under axlarna',
      'Lyft armarna ut åt sidorna med lätt böjda armbågar',
      'Kläm skulderbladen i toppen',
      'Sänk kontrollerat'
    ],
    tips: 'Lätt vikt, hög volym. Armbågarna pekar mot taket i toppen.'
  },
  uprightRow: {
    name: 'Uppåtrodd',
    muscle: 'Sidoaxel, Trapezius',
    equipment: 'Skivstång / Hantlar / Kabel',
    image: IMAGES.uprightRow,
    isCompound: true,
    importance: 'VALFRI',
    description: 'Tränar sidoaxel och traps. OBS: Kan vara hård för axelleden.',
    steps: [
      'Stå med vikten framför dig, smalt grepp',
      'Dra vikten uppåt längs kroppen',
      'Armbågarna går ut och upp',
      'Stopp när armbågarna är i axelhöjd',
      'Sänk kontrollerat'
    ],
    tips: 'Om det gör ont i axeln - skippa denna övning. Sidolyft är ett säkrare alternativ.'
  },

  // ============================================
  // ARMAR - BICEPS
  // ============================================
  bicepCurl: {
    name: 'Bicepscurl (Stång/Hantel)',
    muscle: 'Biceps',
    equipment: 'Skivstång / Hantlar',
    image: IMAGES.bicepCurl,
    isCompound: false,
    importance: 'VIKTIG',
    description: 'Klassisk bicepsövning. Bygger volym och toppar på överarmen.',
    steps: [
      'Stå med vikter i händerna, armar längs sidorna',
      'Handflatorna vänder framåt',
      'Böj armbågarna och lyft vikterna mot axlarna',
      'Håll överarmarna helt stilla mot kroppen',
      'Kläm biceps i toppen',
      'Sänk kontrollerat till raka armar'
    ],
    tips: 'Svinga inte! Endast underarmarna ska röra sig. Använd spegel för att checka formen.'
  },
  hammerCurl: {
    name: 'Hammarcurl',
    muscle: 'Biceps, Brachialis, Underarm',
    equipment: 'Hantlar',
    image: IMAGES.hammerCurl,
    isCompound: false,
    importance: 'VIKTIG',
    description: 'Neutralt grepp tränar brachialis som ger armarna mer tjocklek.',
    steps: [
      'Stå med hantlar längs sidorna',
      'Handflatorna vänder mot varandra (neutralt grepp)',
      'Böj armbågarna och lyft mot axlarna',
      'Håll "hammargreppet" genom hela rörelsen',
      'Sänk kontrollerat'
    ],
    tips: 'Bra komplement till vanlig curl. Tränar även underarmarna.'
  },
  preacherCurl: {
    name: 'Preacher Curl / Scott Curl',
    muscle: 'Biceps',
    equipment: 'Preacher-bänk + Stång/Hantel',
    image: IMAGES.preacherCurl,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Eliminerar fusk och isolerar biceps fullständigt. Bra för full stretch.',
    steps: [
      'Sitt vid preacher-bänken med armarna på kudden',
      'Armhålorna ska vila mot kuddkanten',
      'Curl vikten upp mot axlarna',
      'Sänk långsamt och känn stretch i botten',
      'Full rörelseomfång är viktigt'
    ],
    tips: 'Gå inte för tungt - full stretch i botten kan skada om du tappar kontrollen.'
  },
  inclineCurl: {
    name: 'Incline Dumbbell Curl',
    muscle: 'Biceps (lång huvud)',
    equipment: 'Lutande bänk + Hantlar',
    image: IMAGES.inclineCurl,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Sätter biceps i stretch-position. Fantastisk för att bygga "toppen".',
    steps: [
      'Ställ bänken i 45-60° lutning',
      'Ligg med ryggen mot bänken, armar hängande',
      'Curl hantlarna upp utan att flytta överarmarna',
      'Fokusera på stretch i botten',
      'Kläm biceps i toppen'
    ],
    tips: 'Använd lättare vikt än vanlig curl - stretchen gör det hårdare.'
  },

  // ============================================
  // ARMAR - TRICEPS
  // ============================================
  tricepPushdown: {
    name: 'Triceps Pushdown',
    muscle: 'Triceps',
    equipment: 'Kabel med stång/rep',
    image: IMAGES.tricepPushdown,
    isCompound: false,
    importance: 'VIKTIG',
    description: 'Klassisk tricepsövning. Bra för att isolera och känna muskeln arbeta.',
    steps: [
      'Stå framför kabelmaskinen med stång/rep',
      'Armbågar intill kroppen genom hela rörelsen',
      'Pressa ned till helt raka armar',
      'Kläm triceps hårt i botten',
      'Släpp upp kontrollerat till 90°'
    ],
    tips: 'Armbågarna ska vara låsta vid sidan - endast underarmarna rör sig.'
  },
  skullCrusher: {
    name: 'Skull Crushers / Lying Extension',
    muscle: 'Triceps',
    equipment: 'EZ-stång / Hantlar + Bänk',
    image: IMAGES.skullCrusher,
    isCompound: false,
    importance: 'VIKTIG',
    description: 'Utmärkt för att bygga triceps-massa. Ger full stretch.',
    steps: [
      'Ligg på bänk med vikten rakt upp över ansiktet',
      'Sänk vikten mot pannan genom att bara böja armbågarna',
      'Överarmarna ska vara stilla och vertikala',
      'Sträck armarna tillbaka till start',
      'Full kontroll hela vägen'
    ],
    tips: 'Trots namnet - sänk INTE vikten mot skallen! Sikta strax bakom pannan.'
  },
  tricepExtension: {
    name: 'Overhead Tricep Extension',
    muscle: 'Triceps (lång huvud)',
    equipment: 'Hantel / Kabel',
    image: IMAGES.tricepExtension,
    isCompound: false,
    importance: 'VIKTIG',
    description: 'Sätter triceps i stretch-position. Viktigt för komplett triceps-utveckling.',
    steps: [
      'Sitt eller stå med hantel/rep över huvudet',
      'Sänk vikten bakom huvudet genom att böja armbågarna',
      'Armbågarna pekar framåt hela tiden',
      'Känn stretch i triceps',
      'Sträck armarna tillbaka upp'
    ],
    tips: 'Håll armbågarna nära huvudet - de ska inte glida ut åt sidorna.'
  },
  closeGripBenchPress: {
    name: 'Trångfatt bänkpress',
    muscle: 'Triceps, Bröst',
    equipment: 'Bänk + Skivstång',
    image: IMAGES.closeGripBench,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Compound-övning för triceps. Tillåter tung belastning.',
    steps: [
      'Ligg på bänken som vanlig bänkpress',
      'Grepp axelbrett eller lite smalare',
      'Sänk stången mot nedre bröstet',
      'Håll armbågarna nära kroppen',
      'Pressa upp till raka armar'
    ],
    tips: 'Gå inte för smalt - axelbrett räcker. För smalt grepp belastar handlederna.'
  },
  tricepDips: {
    name: 'Bänk-dips',
    muscle: 'Triceps',
    equipment: 'Bänk / Stol',
    image: IMAGES.tricepDips,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Enkel övning som kan göras överallt. Bra för nybörjare och hemmaträning.',
    steps: [
      'Sitt på kanten av bänken, händer vid höfterna',
      'Flytta rumpan framför bänken',
      'Böj knäna (lättare) eller sträck benen (svårare)',
      'Sänk kroppen genom att böja armbågarna till 90°',
      'Pressa upp till raka armar'
    ],
    tips: 'Håll ryggen nära bänken. Lägg vikt i knät för mer utmaning.'
  },

  // ============================================
  // CORE / MAGE
  // ============================================
  plank: {
    name: 'Planka',
    muscle: 'Hela core',
    equipment: 'Ingen',
    image: IMAGES.plank,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Grundläggande core-övning. Bygger stabilitet och uthållighet i hela bålen.',
    steps: [
      'Lägg dig på mage',
      'Res dig upp på armbågar och tår',
      'Armbågarna rakt under axlarna',
      'Kroppen i en helt rak linje',
      'Spänn magen hårt och håll positionen',
      'Andas normalt'
    ],
    tips: 'Låt inte höften sjunka eller sticka upp. Börja med 30 sek, bygg upp till 60+ sek.'
  },
  sidePlank: {
    name: 'Sidoplanka',
    muscle: 'Sneda magmuskler, Core',
    equipment: 'Ingen',
    image: IMAGES.sidePlank,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'Tränar de sneda magmusklerna och lateral core-stabilitet.',
    steps: [
      'Ligg på sidan med armbågen under axeln',
      'Stapla fötterna på varandra',
      'Lyft höften så kroppen bildar en rak linje',
      'Övre handen på höften eller sträckt uppåt',
      'Håll positionen, byt sedan sida'
    ],
    tips: 'Pressa aktivt bort från golvet. Höften ska inte sjunka.'
  },
  hangingLegRaise: {
    name: 'Hängande benlyft',
    muscle: 'Nedre mage, Höftböjare',
    equipment: 'Pull-up stång',
    image: IMAGES.hangingLegRaise,
    isCompound: true,
    importance: 'VIKTIG',
    description: 'En av de mest effektiva magövningarna. Kräver styrka och kontroll.',
    steps: [
      'Häng från en stång med raka armar',
      'Lyft benen framåt med kontroll',
      'För raka ben: lyft till 90° eller högre',
      'För böjda knän: dra knäna mot bröstet',
      'Sänk långsamt och motverka svängning'
    ],
    tips: 'Börja med böjda knän om raka ben är för svårt. Undvik att svinga.'
  },
  legRaise: {
    name: 'Liggande benlyft',
    muscle: 'Nedre mage',
    equipment: 'Bänk / Golv',
    image: IMAGES.legRaise,
    isCompound: false,
    importance: 'VIKTIG',
    description: 'Tränar nedre magmusklerna. Enklare variant av hängande benlyft.',
    steps: [
      'Ligg på rygg med raka ben',
      'Händer under rumpan för stöd',
      'Lyft benen till 90° med kontroll',
      'Sänk benen långsamt - stopp strax ovan golvet',
      'Håll nedre ryggen pressad mot golvet'
    ],
    tips: 'Om ryggen lyfter har du gått för långt ner. Böj knäna för enklare variant.'
  },
  crunch: {
    name: 'Crunches',
    muscle: 'Raka magmuskeln',
    equipment: 'Ingen',
    image: IMAGES.crunch,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Klassisk magövning. Fokuserar på övre delen av magen.',
    steps: [
      'Ligg på rygg med böjda knän, fötter i golvet',
      'Händer bakom huvudet eller korsade på bröstet',
      'Lyft axlarna från golvet genom att spänna magen',
      'Fokusera på att "krulla" bröstkorgen mot höften',
      'Sänk kontrollerat - släpp inte helt ner'
    ],
    tips: 'Dra INTE i nacken med händerna. Blicken mot taket.'
  },
  russianTwist: {
    name: 'Russian Twist',
    muscle: 'Sneda magmuskler',
    equipment: 'Ingen / Viktplatta',
    image: IMAGES.russianTwist,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Rotationsövning för de sneda magmusklerna.',
    steps: [
      'Sitt med böjda knän, fötter i luften eller golvet',
      'Luta överkroppen lätt bakåt (45°)',
      'Håll händerna ihop eller en vikt framför bröstet',
      'Rotera överkroppen åt sidan',
      'Rotera till andra sidan'
    ],
    tips: 'Håll ryggen rak - rotationen ska komma från midjan.'
  },
  deadBug: {
    name: 'Dead Bug',
    muscle: 'Core, Koordination',
    equipment: 'Ingen',
    image: IMAGES.deadBug,
    isCompound: false,
    importance: 'VIKTIG',
    description: 'Fantastisk för core-aktivering och att lära sig hålla ryggen neutral.',
    steps: [
      'Ligg på rygg med armarna mot taket',
      'Knäna böjda i 90° över höfterna',
      'Pressa nedre ryggen mot golvet',
      'Sänk motsatt arm och ben mot golvet samtidigt',
      'Tillbaka till start, byt sida'
    ],
    tips: 'Ryggen måste vara platt mot golvet hela tiden. Långsam kontrollerad rörelse.'
  },
  abWheel: {
    name: 'Ab Wheel Rollout',
    muscle: 'Hela core, Lats',
    equipment: 'Ab wheel / Skivstång',
    image: IMAGES.abWheel,
    isCompound: true,
    importance: 'AVANCERAD',
    description: 'Extremt effektiv men avancerad övning. Bygger stålkärna.',
    steps: [
      'Knäna på golvet, grip hjulet framför dig',
      'Rulla framåt genom att sträcka armarna',
      'Håll core spänt och undvik svank i ryggen',
      'Gå så långt du kan med kontroll',
      'Rulla tillbaka genom att kontrahera magen'
    ],
    tips: 'SVÅR övning! Börja med korta rullningar och bygg upp gradvis.'
  },
  cableCrunch: {
    name: 'Cable Crunch',
    muscle: 'Raka magmuskeln',
    equipment: 'Kabel med rep',
    image: IMAGES.cableCrunch,
    isCompound: false,
    importance: 'ISOLERING',
    description: 'Tillåter progressiv överbelastning av magen med vikter.',
    steps: [
      'Knäböj framför kabeln med repet bakom nacken',
      'Håll höfterna stilla',
      'Curl överkroppen ner genom att kontrahera magen',
      'Armbågarna ska gå mot knäna',
      'Sänk kontrollerat tillbaka'
    ],
    tips: 'Rörelsen ska komma från magen, inte höfterna. Fokusera på squeeze.'
  },
};

// Gruppera övningar för visning
const EXERCISE_GROUPS = [
  { 
    title: 'Ben & Rumpa', 
    subtitle: '🏆 Basövningar markerade',
    ids: ['squat', 'conventionalDeadlift', 'frontSquat', 'romanianDeadlift', 'bulgarianSplitSquat', 'hipThrust', 'legPress', 'lunge', 'legExtension', 'legCurl', 'calfRaise', 'gluteBridge'] 
  },
  { 
    title: 'Bröst', 
    subtitle: '🏆 Basövningar markerade',
    ids: ['benchPress', 'inclineBenchPress', 'dumbbellPress', 'pushUp', 'dips', 'chestFly', 'cableCrossover'] 
  },
  { 
    title: 'Rygg', 
    subtitle: '🏆 Basövningar markerade',
    ids: ['conventionalDeadlift', 'barbellRow', 'pullUp', 'chinUp', 'latPulldown', 'seatedRow', 'dumbbellRow', 'tBarRow', 'facePull', 'shrugs'] 
  },
  { 
    title: 'Axlar', 
    subtitle: '🏆 Basövningar markerade',
    ids: ['overheadPress', 'dumbbellShoulderPress', 'arnoldPress', 'lateralRaise', 'rearDeltFly', 'frontRaise', 'uprightRow'] 
  },
  { 
    title: 'Biceps', 
    subtitle: '',
    ids: ['bicepCurl', 'hammerCurl', 'preacherCurl', 'inclineCurl'] 
  },
  { 
    title: 'Triceps', 
    subtitle: '',
    ids: ['tricepPushdown', 'skullCrusher', 'tricepExtension', 'closeGripBenchPress', 'tricepDips'] 
  },
  { 
    title: 'Core / Mage', 
    subtitle: '',
    ids: ['plank', 'sidePlank', 'hangingLegRaise', 'legRaise', 'crunch', 'russianTwist', 'deadBug', 'abWheel', 'cableCrunch'] 
  },
];

export { EXERCISES };
